import * as React from 'react';
import {Link} from "react-router-dom";
import {RoleStats} from "./RoleStats";
import {RouteComponentProps} from "react-router";

export const StatsOverviewPage = (props: RouteComponentProps) => {
    const roles = [
        { role: 'LP', url: '/vocabulary-cards', title: 'Vocabulary Stats', button: 'Language Professionals' },
        { role: 'ME', url: '/media-cards', title: 'Media Stats', button: 'Media Editors' },
        { role: 'MC', url: '/mnemo-cards', title: 'Mnemo Stats', button: 'Mnemo Creatives' },
    ];

    return <div className={'index-wrapper'}>
        <div className={'index-page'}>
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                    <li className="breadcrumb-item active" aria-current="page">
                        Stats Overview
                    </li>
                </ol>
            </nav>

            { roles.map(item => (
                <div key={item.role}>
                    <div className="row mb-5 mt-5">
                        <div className="col-sm-12 text-center">
                            <h3>{ item.title }</h3>
                        </div>
                    </div>

                    <RoleStats my={false} role={item.role} />

                    <div className={'row mb-5 mt-5'}>
                        <div className={'col-sm-12 text-right'}>
                            <Link to={`${props.match.url}/roles/${item.role.toLowerCase()}`} className={'btn btn-outline-primary'}>See list of all { item.button }</Link>
                            <Link to={`${props.match.url}${item.url}`} className={'btn btn-outline-primary ml-2'}>See all cards</Link>
                        </div>
                    </div>
                </div>
            )) }
        </div>
    </div>
};
